import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Button,
  Box
} from '@mui/material';

import NotesIcon from '@mui/icons-material/Notes';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';

export default function ClinicalNotesSection({
  onNotesUpload,
  onMEATUpload
}) {
  const handleFileUpload = (callback) => (e) => {
    const file = e.target.files[0];
    if (file?.type === 'text/plain') {
      const reader = new FileReader();
      reader.onload = (e) => callback(e.target.result);
      reader.readAsText(file);
    }
  };

  const downloadTemplate = (filename, content) => {
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Card sx={{ mb: 6 }}>
      <CardHeader title="Clinical Notes and MEAT Documentation" sx={{ backgroundColor: '#f5f5f5' }} />
      <CardContent>
        <Grid container spacing={4}>

          {/* Clinical Notes */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
              <NotesIcon sx={{ mr: 1 }} /> Treating Physician's Clinical Notes
            </Typography>
            <Box mt={1} display="flex" gap={2}>
              <Button variant="outlined" component="label">
                Upload .txt file
                <input type="file" hidden onChange={handleFileUpload(onNotesUpload)} accept=".txt" />
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  downloadTemplate(
                    'clinical_notes_template.txt',
                    'Patient reports persistent general discomfort. Recommend increased fluids, rest, and follow-up in 7 days.'
                  )
                }
              >
                Download template
              </Button>
            </Box>
          </Grid>

          {/* MEAT Documentation */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
              <ChecklistRtlIcon sx={{ mr: 1 }} /> MEAT Documentation
            </Typography>
            <Box mt={1} display="flex" gap={2}>
              <Button variant="outlined" component="label">
                Upload .txt file
                <input type="file" hidden onChange={handleFileUpload(onMEATUpload)} accept=".txt" />
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  downloadTemplate(
                    'meat_documentation_template.txt',
                    `Monitor: weekly blood pressure monitoring\nEvaluate: positive response to new treatment\nAssess: stable diagnosis\nTreat: continue current medication`
                  )
                }
              >
                Download template
              </Button>
            </Box>
          </Grid>

        </Grid>
      </CardContent>
    </Card>
  );
}
